import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, ArrowLeft, AlertCircle } from 'lucide-react';
import { Button } from '@shared/components/ui/Button';

const NotFound: React.FC = () => {
  const location = useLocation();

  return (
    <div className="py-12 min-h-[60vh] flex items-center">
      <div className="container max-w-2xl mx-auto text-center">
        <div className="mx-auto w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-6">
          <AlertCircle className="h-10 w-10 text-amber-600" />
        </div>

        <h1 className="text-4xl md:text-5xl font-bold mb-4">Page Not Found</h1>

        <p className="text-lg text-muted-foreground mb-2">
          The page you're looking for doesn't exist or has been moved.
        </p>

        {location.pathname && (
          <p className="text-sm text-muted-foreground mb-8 font-mono bg-gray-100 p-2 rounded inline-block">
            {location.pathname}
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
          <Button
            onClick={() => window.history.back()}
            variant="outline"
            className="inline-flex items-center"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </Button>

          <Link to="/">
            <Button className="inline-flex items-center">
              <Home className="mr-2 h-4 w-4" />
              Return Home
            </Button>
          </Link>
        </div>

        <div className="mt-12 p-6 bg-blue-50 rounded-lg">
          <h3 className="font-semibold text-blue-900 mb-2">Looking for something?</h3>
          <div className="text-sm text-blue-800 space-y-1">
            <p>• <Link to="/dashboard" className="underline hover:text-blue-600">Dashboard</Link> - View your career progress</p>
            <p>• <Link to="/profile" className="underline hover:text-blue-600">My Profile</Link> - Manage your account</p>
            <p>• <Link to="/reports" className="underline hover:text-blue-600">Reports</Link> - Access your career reports</p>
            <p>• <Link to="/user-guide" className="underline hover:text-blue-600">User Guide</Link> - Learn how to use FutureLens</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
